import React, { Component } from 'react'
import { css } from 'emotion'
import {
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
  MediaQuery,
} from 'components'
import { foodGallery, mobilePromotion } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView column center m="0 auto" w="100%" mt="-1px" bg="#171719">
          <CFImage src={mobilePromotion} alt="Food Gallery" w="100%" />
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView column center maxWidth="1400px" w="100%" mt="-5px">
          <CFImage src={foodGallery} alt="Food Gallery" w="100%" />
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
